<template>
  <v-row>
    <v-col cols="auto">
      <rating
        v-model="question.value"
        v-on:change="saveAnswer"
        :left-label="question.scaleLeftLabel"
        :right-label="question.scaleRightLabel"
      ></rating>
      <div v-if="showRequiredError" class="error--text">
        Answer is required
      </div>
    </v-col>
    <template v-if="survey.isPulse">
      <v-col cols="auto" v-if="$vuetify.breakpoint.smAndDown">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :outlined="!question.feedback"
              height="40"
              :color="question.feedback ? 'secondary' : 'lighttext'"
              @click="showFeedback()"
              :class="{ 'd-none': !survey.isPulse || !next_step_enabled }"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>message</v-icon>
            </v-btn>
          </template>
          <span class="pa-2">Leave Feedback</span>
        </v-tooltip>
        <edit-feedback-dialog
          ref="editFeedback"
          v-on:save="saveFeedback"
        ></edit-feedback-dialog>
      </v-col>
      <v-col cols="12" v-else>
        <v-textarea
          outlined
          v-model="question.feedback"
          placeholder="Add (optional) feedback"
          rows="5"
          hide-details
          @blur="saveFeedback(question)"
        >
        </v-textarea>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import Rating from "@/components/common/Rating";
import EditFeedbackDialog from "@/components/survey/EditFeedbackDialog";
export default {
  name: "SurveyQuestionOpinionScale",
  components: { Rating, EditFeedbackDialog },
  props: { showRequiredError: { type: Boolean, default: false } },
  data: () => ({}),
  computed: {
    ...mapGetters({
      step: "survey/step",
      question: "survey/current_step",
      next_step_enabled: "survey/next_step_enabled",
      is_preview: "survey/is_preview",
      survey: "survey/survey"
    })
  },
  methods: {
    saveAnswer() {
      if (this.is_preview) {
        return;
      }
      this.$store
        .dispatch("survey/saveSurveyAnswer", {
          id: this.question.id,
          value: this.question.value
        })
        .catch(() => {
          //redirect to error page
        });
    },
    showFeedback() {
      this.$refs.editFeedback.showDialog(this.question);
    },
    saveFeedback(question) {
      this.$store
        .dispatch("survey/saveSurveyFeedback", {
          value: question.feedback,
          questionId: this.question.id
        })
        .then(() => {
          this.$root.$snackbarSuccess("Feedback saved");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving your feedback."
          );
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-textarea:not(.v-input--is-focused) ::v-deep fieldset {
  border-color: var(--v-lighttext-base) !important;
}
</style>
